<template>
  <Logo
    height="14"
    alt="Grouper - open source no-code database tool and Airtable alternative"
  />
</template>

<script>
export default {
  name: 'ExternalLinkGrouperLogo',
}
</script>
